import { mapCanBeSold, mapHasAutoSubscription, type ProductBoxLabelCollection } from '@ori/product-box';

import type { ShadeWithPrice } from '../components/SearchPreview/components/SearchPreviewProduct/types';

export const mapEnableQuickBuyButton = (labels: ProductBoxLabelCollection, shades: ShadeWithPrice[]): boolean =>
  mapCanBeSold(labels) ||
  (shades.length > 1 && shades.some((shade) => shade.canBeSold)) ||
  mapHasAutoSubscription(labels);
